import {
  GET_MEDIA_REQUEST,
  GET_MEDIA_REQUEST_SUCCESS,
  GET_MEDIA_REQUEST_ERROR
} from '../types/media';
import { initialState, State, Actions } from '../types/media';

const mediaReducer = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_MEDIA_REQUEST:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_MEDIA_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    case GET_MEDIA_REQUEST_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: true,
          success: false,
        },
      };

    default:
      return state;
  }
};

export default mediaReducer;
